/**
 * =============================================================================
 * ListPageLayout — Esqueleto vertical padrão para páginas de listagem.
 *
 * Empilha verticalmente as seções da página (Header, KPIs, FiltersBar, Content,
 * Footer) com `flex flex-col h-full`. Garante que a tabela ocupe o espaço
 * disponível e o footer permaneça ancorado ao fim.
 *
 * Use em conjunto com:
 *   - <ListPageHeader />
 *   - <ListPageKpis />     (+ <KpiCard />)
 *   - <ListPageFiltersBar />
 *   - <ListPageContent />
 *   - <ListPageFooter />
 *
 * Padrão visual: idêntico ao FinancialCharges (referência canônica do sistema).
 *
 * @version 1.0.0
 * RELEASE: 2026-04-25 v1.0.0 - Criação do helper de listagem padronizada.
 * =============================================================================
 */
import React from 'react';
import { cn } from '@/lib/utils';

interface ListPageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/** Container raiz da página de listagem — flex coluna ocupando 100% da altura. */
export function ListPageLayout({ children, className }: ListPageLayoutProps) {
  return (
    <div className={cn('flex flex-col h-full', className)}>{children}</div>
  );
}
